import React, { Component } from "react";
import Axios from "axios";
import { Link } from "react-router-dom";
import Constant from "../Constant";
import $ from "jquery";
import { getAccessToken } from "../../hooks/AccessToken";
import { Modal, Button, Form } from "react-bootstrap";

class DataManagement extends Component {
  state = {
    ERROR: true,
    DataList: [],
    title: "",
    story_count: 0,
    poem_count: 0,
    type: "",
    status: "",
    icon: null,
    iconPreview: null,
    showModal: false,
    currentBadge: null,
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      this.setState({
        icon: file,
        iconPreview: URL.createObjectURL(file),
      });
    }
  };

  changeStatus = async (id, status) => {
    try {
      let token = getAccessToken();
      const response = await Axios.patch(
        Constant.apiBasePath + "badge/changeStatus/" + id,
        { status: status },
        { headers: { token: token } }
      );
      let { data } = response;
      if (data.status === Constant.statusSuccess) {
        $("#gen-message").text(data.message);
        $("#gen-message").css("color", "green");
        this.handleSubmit();
      } else {
        $("#gen-message").text(data.message);
        $("#gen-message").css("color", "red");
      }
    } catch (err) {
      console.log(err);
    }
  };

  deleteBadge = async (event) => {
    try {
      let token = getAccessToken();
      const response = await Axios.delete(
        Constant.apiBasePath + "badge/" + event,
        { headers: { token: token } }
      );
      let data = response.data;
      if (data.status === Constant.statusSuccess) {
        $("#gen-message").text(data.message);
        $("#gen-message").css("color", "green");
        this.handleSubmit();
        setTimeout(function () {
          $("#gen-message").text("");
        }, 3000);
      } else {
        $("#gen-message").text(data.message);
        $("#gen-message").css("color", "red");
        setTimeout(function () {
          $("#gen-message").text("");
        }, 3000);
      }
    } catch (err) {
      console.log(err);
    }
  };

  updateBadge = (badge) => {
    this.setState({
      currentBadge: badge,
      title: badge.title,
      story_count: badge.story_count || 0,
      poem_count: badge.poem_count || 0,
      type: badge.type,
      status: badge.status,
      iconPreview: badge.icon,
      showModal: true,
    });
  };

  handleSubmit = async () => {
    try {
      let token = getAccessToken();
      const response = await Axios.post(
        Constant.apiBasePath + "badge/get-all",
        { pageNo: 1 },
        { headers: { token: token } }
      );
      const { data } = response.data;
      this.setState({ DataList: data, ERROR: false });
    } catch (err) {
      console.log(err);
    }
  };

  handleModalClose = () => {
    this.setState({
      showModal: false,
      currentBadge: null,
      title: "",
      story_count: 0,
      poem_count: 0,
      type: "",
      status: "",
      icon: null,
      iconPreview: null,
    });
  };

  handleModalSave = async () => {
    const { currentBadge, title, story_count, poem_count, type, status, icon } =
      this.state;

    try {
      let token = getAccessToken();

      // Create FormData object for file upload
      const formData = new FormData();
      formData.append("title", title);
      formData.append("story_count", story_count);
      formData.append("poem_count", poem_count);
      formData.append("type", type);
      formData.append("status", status);

      // Only append icon if a new one was selected
      if (icon) {
        formData.append("badgeIcon", icon);
      }

      const response = await Axios.patch(
        Constant.apiBasePath + "badge/edit/" + currentBadge._id,
        formData,
        {
          headers: {
            token: token,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      let data = response.data;
      if (data.status === Constant.statusSuccess) {
        $("#gen-message").text(data.message);
        $("#gen-message").css("color", "green");
        this.handleSubmit();
        this.handleModalClose();
      } else {
        $("#gen-message").text(data.message);
        $("#gen-message").css("color", "red");
      }
    } catch (err) {
      console.log(err);
    }
  };

  componentDidMount() {
    this.handleSubmit();
  }

  render() {
    const {
      DataList,
      showModal,
      title,
      story_count,
      poem_count,
      type,
      status,
      iconPreview,
    } = this.state;
    let i = 0;

    let bodyData = "";
    if (DataList.length > 0) {
      bodyData = DataList.map((el) => {
        i++;
        let statusLabel = el.status === 1 ? "Active" : "Inactive";
        let typeLabel = el.type === "reader" ? "Reader" : "Writer";
        let requirementsText = `Stories: ${el.story_count || 0}, Poems: ${
          el.poem_count || 0
        }`;

        return (
          <tr key={el._id}>
            <td>{i}</td>
            <td>{typeLabel}</td>
            <td className="namecol">{requirementsText}</td>
            <td>{el.title}</td>
            <td>
              <img src={el.icon} alt="ind" style={{ width: 50, height: 50 }} />
            </td>
            <td>
              {el.status === 1 ? (
                <span className="badge badge-success">Active</span>
              ) : (
                <span className="badge badge-secondary">Inactive</span>
              )}
            </td>
            <td className="namecol">
              <button
                className="btn btn-danger Banner-btn"
                onClick={() => {
                  if (window.confirm("Delete the Badge?")) {
                    this.deleteBadge(el._id);
                  }
                }}
              >
                <i className="mdi mdi-delete" title="Delete Badge"></i>
              </button>
              <button
                className="btn btn-info Banner-btn edit-banner ml5"
                onClick={() => {
                  this.updateBadge(el);
                }}
              >
                <i
                  className="mdi mdi-square-edit-outline"
                  title="Update Badge"
                ></i>
              </button>
            </td>
          </tr>
        );
      });
    }

    return (
      <div className="content-page">
        <div className="content">
          <div className="header-common">
            <div className="center-items">
              <div className="page-title-box">
                <h4 className="page-title-heading">Badge Management</h4>
              </div>
            </div>
            <div className="center-items text-right">
              <Link to="/add-badge">
                <button
                  type="button"
                  className="btn-info btn-sm mb-2 mr-2 float-right"
                >
                  Add New
                </button>
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="tab-content table-wrapper">
                    <div
                      className="tab-pane show active"
                      id="buttons-table-preview"
                    >
                      <table
                        id="complex-header-datatable"
                        className="table dt-responsive nowrap"
                      >
                        <thead>
                          <tr>
                            <th>S.No.</th>
                            <th>Type</th>
                            <th>Requirements</th>
                            <th>Title</th>
                            <th>Icon</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>{bodyData}</tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal show={showModal} onHide={this.handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Update Badge</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="formTitle">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={title}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Form.Group controlId="formStoryCount">
                <Form.Label>Story Count</Form.Label>
                <Form.Control
                  type="number"
                  name="story_count"
                  value={story_count}
                  onChange={this.handleChange}
                  min="0"
                />
              </Form.Group>
              <Form.Group controlId="formPoemCount">
                <Form.Label>Poem Count</Form.Label>
                <Form.Control
                  type="number"
                  name="poem_count"
                  value={poem_count}
                  onChange={this.handleChange}
                  min="0"
                />
              </Form.Group>
              <Form.Group controlId="formType">
                <Form.Label>Type</Form.Label>
                <Form.Control
                  as="select"
                  name="type"
                  value={type}
                  onChange={this.handleChange}
                >
                  <option value="writer">Writer</option>
                  <option value="reader">Reader</option>
                </Form.Control>
              </Form.Group>
              <Form.Group controlId="formStatus">
                <Form.Label>Status</Form.Label>
                <Form.Control
                  as="select"
                  name="status"
                  value={status}
                  onChange={this.handleChange}
                >
                  <option value="0">Inactive</option>
                  <option value="1">Active</option>
                </Form.Control>
              </Form.Group>
              <Form.Group controlId="formIcon">
                <Form.Label>Icon</Form.Label>
                <div className="mb-3">
                  <div className="current-image mb-2">
                    <label>Current Image:</label>
                    {iconPreview && (
                      <div className="preview-container mt-2">
                        <img
                          src={iconPreview}
                          alt="Current Badge Icon"
                          className="img-thumbnail"
                          style={{ maxWidth: "100px", maxHeight: "100px" }}
                        />
                      </div>
                    )}
                  </div>
                  <div className="new-image">
                    <Form.Label>Upload New Image (Optional)</Form.Label>
                    <Form.Control
                      type="file"
                      name="icon"
                      accept="image/*"
                      onChange={this.handleImageChange}
                    />
                    <Form.Text className="text-muted">
                      Leave empty to keep the current image.
                    </Form.Text>
                  </div>
                </div>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleModalClose}>
              Close
            </Button>
            <Button variant="primary" onClick={this.handleModalSave}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default DataManagement;
